import { render, staticRenderFns } from "./OnboardingQuestionInfo.vue?vue&type=template&id=609c48ff"
import script from "./OnboardingQuestionInfo.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports